import EnseigneFormsModal from './EnseigneFormsModal';

export default EnseigneFormsModal;
